import firebase from '../../lib/firebase.prod';

export async function sendPasswordEmailToUser(
	salesAgentName,
	userEmail,
	password
) {
	let emailRef = await firebase
		.database()
		.ref('/passwordEmailToUser/')
		.push();

	await emailRef.set({
		salesAgentName: salesAgentName,
		userEmail: userEmail,
		password: password,
		subject: `${salesAgentName} has reset password for ${userEmail}`,
	});
}
